import { usePartnersPageContent } from '@/features/partners/hooks/usePartnersPage';
import { SectionWrapper } from './SectionWrapper';
import { SectionTitle } from './SectionTitle';

export function FeaturesSection() {
  const { partnerPageContent, isLoading } = usePartnersPageContent();
  const { intro, highlights } = partnerPageContent;

  if (isLoading) return null;

  return (
    <SectionWrapper id="features" aria-labelledby="features-title">
      <SectionTitle
        id="features-title"
        title={intro.title}
        subtitle={intro.paragraphs[0]}
      />

      {intro.paragraphs[1] ? (
        <p className="mx-auto mb-8 max-w-3xl text-center text-base text-muted-foreground md:text-lg">
          {intro.paragraphs[1]}
        </p>
      ) : null}

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {highlights.map((feature, index: number) => (
          <div
            key={index}
            className="rounded-3xl border border-border bg-white p-6"
          >
            <p className="font-semibold text-foreground mb-1">{feature.title}</p>
            <p className="text-muted-foreground text-sm">{feature.description}</p>
          </div>
        ))}
      </div>
    </SectionWrapper>
  );
}

export default FeaturesSection;
